/**
 * Slug derivation for the editor.
 *
 * The API validates slugs against `^[a-z0-9]+(-[a-z0-9]+)*$` (ASCII kebab), so the
 * editor pre-fills one from the title. Czech titles are full of diacritics; NFD
 * decomposition splits each accented letter into its base letter plus a combining
 * mark, and dropping the marks is what turns "říjen" into "rijen".
 */

const MAX_SLUG_LENGTH = 160; // mirrors the column width

/** The API's slug rule. */
export const SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;

export function slugify(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, MAX_SLUG_LENGTH)
    .replace(/-+$/, "");
}
